import imageCompression from 'browser-image-compression';
import config from '../config';

// Compress image before upload
export const compressImage = async (file) => {
  try {
    const compressedFile = await imageCompression(file, config.compressionOptions);
    return compressedFile;
  } catch (error) {
    console.error('Error compressing image:', error);
    return file; // Return original if compression fails
  }
};

// Apply image adjustments using Canvas API
export const applyImageAdjustments = async (imageUrl, adjustments) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      canvas.width = img.width;
      canvas.height = img.height;
      
      // Apply filters
      ctx.filter = `
        brightness(${adjustments.brightness}%)
        contrast(${adjustments.contrast}%)
        saturate(${adjustments.saturation}%)
        ${adjustments.sharpen > 0 ? `blur(${1 / adjustments.sharpen}px)` : ''}
      `.trim();
      
      ctx.drawImage(img, 0, 0);
      
      // Convert to blob
      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Failed to create blob'));
          }
        },
        'image/jpeg',
        config.imageQuality
      );
    };
    
    img.onerror = () => {
      reject(new Error('Failed to load image'));
    };
    
    img.src = imageUrl;
  });
};

// Create thumbnail URL
export const createThumbnailUrl = (photo) => {
  if (photo.url.startsWith('http')) {
    return photo.url;
  }
  return `${config.apiUrl.replace('/api', '')}${photo.url}`;
};

// Format file size
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};

// Validate file type
export const isValidImageFile = (file) => {
  return config.supportedFormats.includes(file.type);
};

// Generate unique ID
export const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

